var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandAllBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    classs: "expand-all",
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.684,
    height: 34.684,
    rx: 10,
    fill: "#112A63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 6.93677H12.3287C11.582 7.65399 10.8365 8.37013 10.0288 9.14403C11.8894 10.9883 13.6116 12.6964 15.3425 14.4109C15.0123 14.7227 14.6994 15.0181 14.3997 15.3004C12.7243 13.6185 11.0152 11.9018 9.26031 10.1403C8.48313 10.9709 7.78335 11.7175 7.08356 12.4653C7.03451 12.4293 6.98655 12.3944 6.9375 12.3585V6.93677Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2743 19.2539C14.682 19.6441 14.9937 19.9428 15.2989 20.2371C13.5953 21.9299 11.8763 23.6379 10.0789 25.4223C10.9073 26.2256 11.6485 26.945 12.4747 27.7472H6.9375V22.3005C7.6569 23.046 8.3556 23.7698 9.06301 24.5045C10.867 22.6863 12.5826 20.9576 14.2732 19.2539H14.2743Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5674 9.28031C23.7172 8.45081 22.9924 7.7434 22.1836 6.95532H27.6914V12.3574C26.9774 11.6151 26.2722 10.8815 25.5637 10.1447C23.7358 11.9835 22.0266 13.7046 20.2837 15.4585C19.9251 15.0737 19.6308 14.7576 19.3594 14.4666C21.062 12.7716 22.7776 11.0636 24.5685 9.2814L24.5674 9.28031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6019 25.5367C22.7347 23.6782 21.0266 21.9789 19.3164 20.2774C19.6314 19.9569 19.9432 19.6397 20.2691 19.3083C21.9695 21.0142 23.6721 22.7212 25.3954 24.4499C26.13 23.6967 26.8429 22.9653 27.5569 22.2339C27.6016 22.2644 27.6452 22.2961 27.6898 22.3266V27.7461H22.2213C23.0322 26.994 23.7811 26.2986 24.6029 25.5367H24.6019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAllBlue);
export default __webpack_public_path__ + "static/media/ExpandAllBlue.c57ba35190f703ce51429b9c4f059182.svg";
export { ForwardRef as ReactComponent };